import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appInput]',
  standalone: true,
})
export class InputDirective {
  nativeElement:
    | HTMLInputElement
    | HTMLSelectElement
    | HTMLTextAreaElement
    | HTMLButtonElement;
  constructor(private el: ElementRef) {
    if (
      this.el.nativeElement instanceof HTMLInputElement ||
      this.el.nativeElement instanceof HTMLSelectElement ||
      this.el.nativeElement instanceof HTMLTextAreaElement ||
      this.el.nativeElement instanceof HTMLButtonElement
    ) {
      this.nativeElement = this.el.nativeElement;
      return;
    }

    console.error('appInput directive used on unsupported type');
  }
}
